import React, { useEffect, useState } from "react";
import Sidenav from "../../Navbar/sideNav/page";
import HeaderSection from "../../Navbar/page";
import FooterSection from "../../footer/page";
import Api from "../../Api/Api";
import { useNavigate, useParams } from "react-router-dom";
import { RingLoader } from "react-spinners";

function Page() {
  const [scores, setScore] = useState([]);
  const gameId = useParams();
  const [loading, setLoading] = useState(false);
  const [totalPageData, setTotalPageData] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;

  const indexOfLast = currentPage * itemsPerPage;
  const indexOfFirst = indexOfLast - itemsPerPage;
  const navigate= useNavigate();

  const handlePagination = (pageNo) => {
    const totalPages = Math.ceil(totalPageData / itemsPerPage);
    if (currentPage < totalPages) setCurrentPage(currentPage + 1);

    if (currentPage > 1) setCurrentPage(currentPage - 1);
  };

  const getLeaderboardScore = async () => {
    setLoading(true);
    try {
      const response = await Api.get(
        `/user/get-leaderboard?gameid=${gameId.id}`
      );
      // console.log("Leaderboard", response.data);
      setScore(response.data.result.leaderboard);
      setTotalPageData(response.data.result.total);
    } catch (error) {
      console.log("Error", error);
    }
    setLoading(false);
  };

  useEffect(() => {
    getLeaderboardScore();
  }, [currentPage]);
  return (
    <>
      {loading ? (
        <div
          className="d-flex justify-content-center"
          style={{ marginTop: "30%", marginBottom: "20%" }}
        >
          {/* <Loader/> */}
          <RingLoader color="rgb(50 92 213)" size="100" />
        </div>
      ) : (
        <>
        {/* <HeaderSection /> */}
          <section className="banner-section inner-banner position-relative about">
            <div className="shape-area">
              <img
                src="/assets/images/abs-items/bubble.png"
                className="shape-1"
                alt="icon"
              />
              <img
                src="/assets/images/abs-items/ellipse-7.png"
                className="shape-2"
                alt="icon"
              />
            </div>
            <div className="container position-relative">
              <div
                style={{ marginTop: "9%", width: "30px", cursor: "pointer" }}
              >
                <i class="fa fa-arrow-left" onClick={() => navigate(-1)}></i>
              </div>
              <div className="banner-content row justify-content-between">
                <div className="col-lg-6 col-md-10">
                  <div className="main-content">
                    <h2 className="visible-slowly-bottom display-four mb-6">
                      Leaderboard
                    </h2>
                  </div>
                </div>
                <div className="col-lg-6 col-md-10 d-grid align-items-end justify-content-end">
                  <div className="breadcrumb-area position-absolute end-0 bottom-0">
                    <nav aria-label="breadcrumb">
                      <ol className="breadcrumb m-0 py-3 px-8 fs-six d-flex align-items-end justify-content-end">
                        <li className="breadcrumb-item p-0 m-0">
                          <a onClick={() => navigate("/")}>Home</a>
                        </li>
                        <li
                          className="breadcrumb-item active"
                          aria-current="page"
                          // onClick={() => navigate("/leaderboard")}
                        >
                          <a onClick={() => navigate("/leaderboard")}>
                            Leaderboard
                          </a>
                        </li>
                        <li
                          className="breadcrumb-item active"
                          aria-current="page"
                          // onClick={() => navigate("/leaderboard")}
                        >
                          <a onClick={() => navigate(-1)}>
                            Level {scores[0]?.gameLevel}
                          </a>
                        </li>
                        <li
                          className="breadcrumb-item active"
                          aria-current="page"
                          // onClick={() => navigate("/leaderboard")}
                        >
                          <a onClick={() => navigate("/leaderboard/games")}>
                            Game
                          </a>
                        </li>
                        {/* <li className="breadcrumb-item p-0 m-0">
                          <a href="index.html">Home</a>
                        </li> */}
                      </ol>
                    </nav>
                  </div>
                </div>
              </div>
            </div>
          </section>

          <section className="call-to-action  bettor-ranking overflow-hidden">
            <div className="container">
              <div className="row justify-content-between align-items-center">
                <div className="col-lg-8 offset-2">
                  <div className="leaderboard">
                    <h2 className="text-center">
                      Level {scores[0]?.gameLevel} Team Leaderboard{" "}
                    </h2>
                    <h3 style={{ textAlign: "center" }}>
                      {" "}
                      {scores[0]?.qualified === "Waiting"
                        ? " Result Awaited"
                        : scores[0]?.qualified === "Disqualified"
                        ? "No one qualified the game"
                        : ""}
                    </h3>
                    <div
                      className="leaderboard-box-1 mt-5 mb-3"
                      style={{ gridTemplateColumns: "3% 46% 18% 15% 20%" }}
                    >
                      <h5>Serial No.</h5>
                      <h5>UserName</h5>
                      <h5>Score</h5>
                      <h5>Time</h5>
                      {scores[0]?.qualified === "Qualified" ? <h5></h5> : ""}
                    </div>
                    {/* <div className="leaderboard-box">
                        <p className="text-center">1</p>
                        <div className="profil-lead pd-more pd-more">
                          <img src="/assets/images/team-members-1.png" />
                          <h5>Sophia Smith</h5>
                        </div>

                        <p className="text-center">2555</p>
                        <p className="text-center">Level 1</p>
                        <p className="text-center">Qualify</p>
                      </div> */}
                    {scores.length === 0 ? (
                      <div className="leaderboard-box">
                        <p className="text-center">No data found</p>
                        {/* <div className="profil-lead pd-more pd-more">
                            <img src="/assets/images/team-members-1.png" />
                            <h5>Sophia Smith</h5>
                          </div>

                          <p className="text-center">2555</p>
                          <p className="text-center">Level 1</p>
                          <p className="text-center">Qualify</p> */}
                      </div>
                    ) : (
                      scores.map((score, index) => (
                        <div
                          className="leaderboard-box mt-2"
                          style={{
                            gridTemplateColumns: "9% 42% 14% 20% 20%",
                          }}
                        >
                          <p className="text-center">{index + 1}</p>
                          <div className="profil-lead pd-more">
                            {/* <img src="/assets/images/team-members-1.png" /> */}
                            <h5>{score?.userId?.userName}</h5>
                          </div>

                          <p className="text-center">{score?.score}</p>
                          <p className="text-center">
                            {Math.floor(score.timeTaken / 60)}m:
                            {Math.floor(score.timeTaken % 60)}s
                          </p>
                          {score?.qualified === "Qualified" ? (
                            <p>
                              <img
                                src="/assets/images/trophy.png"
                                alt=""
                                style={{
                                  height: "40px",
                                  width: "40px",
                                  borderRadius: "48%",
                                  marginLeft: "20%",
                                }}
                              />
                            </p>
                          ) : (
                            ""
                          )}

                          {/* <p className="text-center">{score?.qualified}</p> */}
                        </div>
                      ))
                    )}
                  </div>
                </div>
              </div>

              
            </div>
          </section>
          <FooterSection />
        </>
      )}
    </>
  );
}

export default Page;
